/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserGroupMember } from '../models/user-group-member';
@Injectable({
  providedIn: 'root',
})
class UserGroupMembersService extends __BaseService {
  static readonly UserGroupMembersGetPath = '/user-group-members/{memberId}';
  static readonly UserGroupMembersDeletePath = '/user-group-members/{memberId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the requested user group member
   * @param params The `UserGroupMembersService.UserGroupMembersGetParams` containing the following parameters:
   *
   * - `memberId`: GUID of the user group member
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  UserGroupMembersGetResponse(params: UserGroupMembersService.UserGroupMembersGetParams): __Observable<__StrictHttpResponse<UserGroupMember>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/user-group-members/${encodeURIComponent(String(params.memberId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserGroupMember>;
      })
    );
  }
  /**
   * Returns the requested user group member
   * @param params The `UserGroupMembersService.UserGroupMembersGetParams` containing the following parameters:
   *
   * - `memberId`: GUID of the user group member
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  UserGroupMembersGet(params: UserGroupMembersService.UserGroupMembersGetParams): __Observable<UserGroupMember> {
    return this.UserGroupMembersGetResponse(params).pipe(
      __map(_r => _r.body as UserGroupMember)
    );
  }

  /**
   * Finishes user membership in a user group
   * @param params The `UserGroupMembersService.UserGroupMembersDeleteParams` containing the following parameters:
   *
   * - `memberId`: GUID of the user group member
   *
   * - `Authorization`: Bearer JSON Web Token
   */
  UserGroupMembersDeleteResponse(params: UserGroupMembersService.UserGroupMembersDeleteParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/user-group-members/${encodeURIComponent(String(params.memberId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Finishes user membership in a user group
   * @param params The `UserGroupMembersService.UserGroupMembersDeleteParams` containing the following parameters:
   *
   * - `memberId`: GUID of the user group member
   *
   * - `Authorization`: Bearer JSON Web Token
   */
  UserGroupMembersDelete(params: UserGroupMembersService.UserGroupMembersDeleteParams): __Observable<null> {
    return this.UserGroupMembersDeleteResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

namespace UserGroupMembersService {

  /**
   * Parameters for UserGroupMembersGet
   */
  export interface UserGroupMembersGetParams {

    /**
     * GUID of the user group member
     */
    memberId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }

  /**
   * Parameters for UserGroupMembersDelete
   */
  export interface UserGroupMembersDeleteParams {

    /**
     * GUID of the user group member
     */
    memberId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { UserGroupMembersService }